export * from './ProductTabsContent';
